export default "__VITE_ASSET__2af67196__"